module.exports = __webpack_public_path__ + "assets/img/right-title-open-69497e81.png";